// Simple tooltip component (placeholder for shadcn/ui tooltip)
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const TooltipProvider = ({ children }: { children: ReactNode }) => <>{children}</>;

interface TooltipProps {
  children: ReactNode;
}

export const Tooltip = ({ children }: TooltipProps) => {
  return <div className="relative inline-block">{children}</div>;
};

interface TooltipTriggerProps {
  children: ReactNode;
  asChild?: boolean;
}

export const TooltipTrigger = ({ children }: TooltipTriggerProps) => {
  return <>{children}</>;
};

interface TooltipContentProps {
  children: ReactNode;
  className?: string;
}export const TooltipContent = ({ children, className }: TooltipContentProps) => {
  // Simple tooltip that shows on hover via CSS
  return (
    <div 
      className={cn(
        "absolute z-50 hidden group-hover:block bottom-full left-1/2 -translate-x-1/2 mb-2",
        "px-3 py-1.5 text-sm text-popover-foreground bg-popover rounded-md shadow-md border",
        className
      )}
    >
      {children}
    </div>
  );
};
